import cx from 'classnames';
import { startCase, toLower } from 'lodash';
import React, { Fragment, useState } from 'react';
import { useEffect } from 'react';
import { Button as BootstrapBtn, Image, Offcanvas } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { AddPlusIcon } from '../assets/icons';
import { SearchInput } from '../common';
import { USER_PROFILE_PLACEHOLDER } from '../config/constant/assetConstant';
import {
  With_Me_Value,
  With_Organisation_Value,
  With_Team_Member_Value,
} from '../constants/filters';
import { RemoveAllWhiteSpaceFromString } from '../helpers/jsHelper';
import {
  selectSharedPanelOpenBy,
  selectSharedTo,
  setSelectedAllMembers,
  setSelectedAllTeam,
  setSelectedMembersBy,
  setSelectedMembersTo,
  setSharedTo,
  setTotalOrganizationMembersCount,
} from '../redux/slicers/filters/filterSlicer';
import { selectTeamMembersFilterOpen } from '../redux/slicers/uiSlicer';
import { SKELETON_LOADER_TYPE } from '../skeletonLoaderUI/SkeletonLoaderUI';
import Button from './Button';
import InfiniteScroll from './InfiniteScroll/InfiniteScroll';
import styles from './SideFilter/FilterItem.module.scss';
import { TeamMembersSharedFilesFilter } from '../common/TeamMembersSharedFilesFilter';
import { useUserContext } from '../contexts/UserContext';
import { isAdminOrOwner } from '../helpers/userHelper';
export const MemberOverlay = ({
  show,
  sections,
  selected,
  onSelectAll,
  onSelect,
  onSearchChange,
  searchValue,
  onClose,
  maxVisible = 5,
  onChange = () => {},
}) => {
  const dispatch = useDispatch();
  const sharedPanelOpenBy = useSelector(selectSharedPanelOpenBy);
  const sharedTo = useSelector(selectSharedTo);
  const { currentUser } = useUserContext();

  const totalSelected = selected.length;
  const itemsCount = sections.reduce((sum, section) => sum + section.items.length, 0);
  const allSelected = itemsCount === totalSelected && totalSelected !== 0;
  const selectedIds = selected.map((m) => m.id);

  const [open, setOpen] = useState(false);
  const [callAgain, setCallAgain] = useState(null);
  const moreCount =
    (sections?.find(({ name }) => name === 'INSIDE_MEMBERS')?.items?.length || 0) - maxVisible;
  const maxVisibleList = () => {
    let list = sections?.find(({ name }) => name === 'INSIDE_MEMBERS');
    if (list) {
      list = [
        {
          ...list,
          items: list?.items?.slice(0, maxVisible),
        },
      ];
    } else {
      list = [];
    }
    return list;
  };
  const visibleItems = moreCount > 0 && !open ? maxVisibleList() : sections;

  useEffect(() => {
    dispatch(setTotalOrganizationMembersCount(itemsCount));
  }, [itemsCount]);

  useEffect(() => {
    if (callAgain) {
      onSelect(callAgain);
      setCallAgain(null)
    }
  }, [callAgain]);

  const handleSelectAll = () => {
    if (sharedTo !== With_Team_Member_Value) {
      dispatch(setSharedTo(With_Team_Member_Value));
    }
    onSelectAll();
  };

  const handleClearAll = () => {
    onChange?.([]);
    dispatch(setSelectedMembersBy([]));
    dispatch(setSelectedMembersTo([]))
    dispatch(setSharedTo(With_Team_Member_Value));
    onClose();
  };

  const handleSelect = (item) => {
    onSelect(item);
    if (sharedTo === With_Me_Value && +currentUser?.id !== item?.id) {
      setCallAgain({ id: +currentUser?.id, name: currentUser?.user?.name , avatar:"" })
    }
    if (sharedTo !== With_Team_Member_Value) {
      dispatch(setSharedTo(With_Team_Member_Value));
    }
  };

  const handleCheckMe = (checked, item) => {
    if (sharedTo === With_Organisation_Value || sharedTo === With_Me_Value) {
      dispatch(setSharedTo(With_Team_Member_Value));
    }
    if (!checked) {
      if (sharedTo === With_Organisation_Value || sharedTo === With_Me_Value) {
        dispatch(setSharedTo(With_Team_Member_Value));
      }
    } else {
      handleSelect(item);
    }
  };

  const isAdminAccess = isAdminOrOwner(currentUser);

  return (
    <Offcanvas
      className={`files-shared-with-users-container sidebar designV2 ${
        sections[0]?.hasMore ? '--has-more-items' : ''
      }`}
      show={show}
      onHide={onClose}
      placement="end"
      backdropClassName="nonVisibleBackdrop">
      <Offcanvas.Header className="align-items-top sidebarHeader">
        <div className="heading-user-title">
          <h4 className="m-0 ellipsis">Filters</h4>
        </div>
        <BootstrapBtn className="sidebarCloseButton" onClick={onClose}>
          Done
        </BootstrapBtn>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="filter-form">
          <div className="fs-container search-members">
            <SearchInput value={searchValue} placeholder="Search" onChange={onSearchChange} />
          </div>
          <div className="fs-container inside members mb-0 pb-0">
            {!isAdminAccess && (
              <div
                className={`all-user-select py-2 shared-type-checkbox ${
                  sharedTo === With_Me_Value ? 'selected' : ''
                }`}>
                <div className="filter select_all checkbox-selection">
                  <input
                    type="checkbox"
                    id="membersOverlayShareWithMe"
                    className="selectCard"
                    checked={sharedTo === With_Me_Value || allSelected}
                    onChange={() => {
                      onChange?.([]);
                      dispatch(setSharedTo(With_Me_Value));
                    }}
                  />
                  <label htmlFor="membersOverlayShareWithMe"></label>
                </div>
                <label htmlFor="membersOverlayShareWithMe">Shared with me</label>
              </div>
            )}
            <div
              className={`all-user-select py-2 shared-type-checkbox ${
                sharedTo === With_Organisation_Value ? 'selected' : ''
              }`}>
              <div className="filter select_all checkbox-selection">
                <input
                  type="checkbox"
                  id="membersOverlayShareWithOrg"
                  className="selectCard"
                  checked={sharedTo === With_Organisation_Value}
                  onChange={() => {
                    onChange?.([]);
                    dispatch(setSharedTo(With_Organisation_Value));
                  }}
                />
                <label htmlFor="membersOverlayShareWithOrg"></label>
              </div>

              <label htmlFor="membersOverlayShareWithOrg">Shared with organization</label>
            </div>
            {/* // share with team option */}
            {isAdminAccess ? (
              <div className={`${styles.root} filter-root-item accordion-item`}>
                <div>
                  <h5
                    className="accordion-header"
                    id={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString(
                      'Shared with Team'?.trim()
                    )}`}>
                    <div
                      className="accordion-button d-flex justify-content-between"
                      data-bs-toggle="collapse"
                      data-bs-target={`#panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                        'Shared with Team'?.trim()
                      )}`}
                      aria-expanded="true"
                      aria-controls={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                        'Shared with Team'?.trim()
                      )}`}>
                      <div className="main-text">Shared with Team</div>
                    </div>
                  </h5>
                </div>

                <div
                  id={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                    'Shared with Team'?.trim()
                  )}`}
                  className="accordion-collapse collapse show"
                  aria-labelledby={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString(
                    'Shared with Team'?.trim()
                  )}`}>
                  <>
                    <div
                      className={`all-user-select py-2 shared-type-checkbox ${
                        allSelected ? 'selected' : ''
                      }`}>
                      <div className="filter select_all checkbox-selection">
                        <input
                          type="checkbox"
                          id="membersOverlaySelectAll"
                          className="selectCard"
                          checked={allSelected}
                          onChange={() => handleSelectAll()}
                        />
                        <label htmlFor="membersOverlaySelectAll"></label>
                      </div>
                      <label htmlFor="membersOverlaySelectAll">All</label>
                      <label className="selectionCount"></label>
                    </div>

                    {/* list code */}

                    {visibleItems?.map((section, idx) => {
                      const { title, items, noItemsText, loading, hasMore, fetchMoreData } =
                        section;
                      if (section?.name === 'OUTSIDE_MEMBERS' && sharedPanelOpenBy === 'admin')
                        return null;

                      return (
                        <Fragment key={idx}>
                          <div className={`members ${idx > 0 ? 'outside' : 'inside'}`}>
                            {title && (
                              <div className="fs-container__members-container mb-2">
                                <h5 className="head-h5">{title}</h5>
                              </div>
                            )}

                            {items.length === 0 && !loading && noItemsText}
                            <InfiniteScroll
                              loading={items?.length && !searchValue ? false : loading}
                              loadingType={SKELETON_LOADER_TYPE.MEMBER}
                              hasMore={hasMore}
                              next={fetchMoreData}>
                              {items.length > 0 && (
                                <ul className="user-list">
                                  {items.map((item) => {
                                    const itemSelected = selectedIds.includes(item.id);
                                    const { name, avatar, organization } = item;
                                    const currentMember = +currentUser?.id === +item?.id;
                                    const checkCurrentUser = sharedTo === With_Me_Value;
                                    return (
                                      <li
                                        className={cx(
                                          'teamMemberFilter',
                                          itemSelected && 'selected'
                                        )}
                                        key={item.id}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={itemSelected}
                                          checked={itemSelected || (currentMember && checkCurrentUser)}
                                          onClick={() => currentMember && checkCurrentUser ? handleCheckMe(itemSelected,item) : handleSelect(item)}
                                        />
                                        <Image src={avatar ? avatar : USER_PROFILE_PLACEHOLDER} />
                                        <div className="user-info">
                                          <h5 className="user-name userName">{`${
                                            currentMember ? "Me" : name
                                          }`}</h5>
                                          {organization && (
                                            <p className="user-org ellipsis" title={organization}>
                                              {startCase(toLower(organization))}
                                            </p>
                                          )}
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                            </InfiniteScroll>
                          </div>
                        </Fragment>
                      );
                    })}
                  </>
                  {+moreCount > 0 ? (
                    <div className={`more pt-1`}>
                      <span
                        className={`${open ? 'show-more' : ''} more-option`}
                        onClick={() => setOpen(!open)}>
                        {!open && (
                          <>
                            <AddPlusIcon />
                            {`View more (${moreCount})`}
                          </>
                        )}
                        {open && (
                          <>
                            <AddPlusIcon />
                            Show less
                          </>
                        )}
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
            <TeamMembersSharedFilesFilter hideOptionList={true} insideOverLay={true} />
          </div>
          <div className="filter-btn">
            <Button variant="outline" color="secondary" onClick={handleClearAll}>
              Clear All
            </Button>
            <Button variant="outline-secondary" onClick={onClose}>
              View
            </Button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
